import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  overflow: hidden;
  background: #f1f3f5;
  max-height: 100dvh;
`;

export const Left = styled.div`
  min-width: 70px;
  width: 70px;
`;

export const Right = styled.div`
  flex: 1;
  overflow: auto;
  position: relative;
`;
